import React, { useState } from 'react';
import { Box, HStack, VStack, View } from 'native-base';
import { SortByModal } from './SortByModal';
import { StoreModal } from './StoreModal';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faShoppingCart, faStore } from '@fortawesome/free-solid-svg-icons';
import { useAppNavigate } from '~/pages';
import { useDutchieStore, useTheme } from '@springbig/shared';
import { SearchBar } from '~/pages/shop/components/SearchBar';
import FilterDrawer from './FilterDrawer';
import { Button } from '~/shared/Theme';

type ShopHeaderProps = {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (value: boolean) => void;
};

export const ShopHeader = ({
    isDrawerOpen = false,
    setIsDrawerOpen
} : ShopHeaderProps) => {

    const {
        button_text,
    } = useTheme();

    const [showSortBy, setShowSortBy] = useState(false);
    const [showStore, setShowStore] = useState(false);
    const { navigate, params } = useAppNavigate();

    const {
        sortByProp,
        retailer,
        fullfillmentOption,
        setShowStoreBottomSheet,
        isBusy,
        cartItemsAmount
    } = useDutchieStore();

    return (
        <>
            <VStack p={4} space={2} alignItems={'center'}>
                <HStack space={2} alignItems={'center'}>
                    <Button
                        text={'shop.filters'}
                        modifier={'small'}
                        disabled={isBusy}
                        onPress={() => {

                            setIsDrawerOpen(true);
                        }}
                    />
                    <Button
                        text={`sort by: ${sortByProp?.label}`}
                        modifier={'small'}
                        disabled={isBusy}
                        onPress={() => {

                            setShowSortBy(true);
                        }}
                    />
                </HStack>
                <HStack space={2} alignItems={'center'}>
                    <Button
                        modifier={'small'}
                        text={`${fullfillmentOption?.label} in ${retailer?.name}`}
                        disabled={isBusy}
                        onPress={() => {

                            setShowStore(true);
                        }}
                    />
                    <Button
                        h={10}
                        w={10}
                        rounded={'full'}
                        modifier={'small'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        disabled={isBusy}
                        onPress={() => {

                            setShowStoreBottomSheet(true);
                        }}
                    >
                        <SpIcon color={button_text} icon={faStore}/>
                    </Button>
                    <Button
                        h={10}
                        w={10}
                        rounded={'full'}
                        modifier={'small'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        disabled={isBusy}
                        onPress={() => {

                            navigate(`w/${params.wallet_id}/shop/cart`);
                        }}
                    >
                        <View>
                            <SpIcon color={button_text} icon={faShoppingCart} />
                            { cartItemsAmount && cartItemsAmount > 0 ?
                                <Box
                                    position={'absolute'}
                                    top={-15}
                                    right={-15}
                                    bg={'red'}
                                    color={'white'}
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    rounded={'full'}
                                    h={4}
                                    w={4}
                                >
                                    <Caption fontSize={10}>
                                        { cartItemsAmount }
                                    </Caption>
                                </Box>
                                :
                                <></>
                            }
                        </View>
                    </Button>
                </HStack>
                <SearchBar />
            </VStack>
            { showSortBy ?
                <SortByModal
                    showSortBy={showSortBy}
                    setShowSortBy={() => {

                        setShowSortBy(!showSortBy);
                    }}
                />
                : null
            }
            { showStore ?
                <StoreModal
                    showStore={showStore}
                    setShowStore={() => {

                        setShowStore(!showStore);
                    }}
                />
                : null
            }
            { isDrawerOpen ?
                <FilterDrawer
                    isDrawerOpen={isDrawerOpen}
                    setIsDrawerOpen={(value) => setIsDrawerOpen(value)}
                />
                : null
            }
        </>
    );
};
